import { render, staticRenderFns } from "./search-empty.vue?vue&type=template&id=bbfeb604&scoped=true&"
import script from "./search-empty.vue?vue&type=script&lang=js&"
export * from "./search-empty.vue?vue&type=script&lang=js&"
import style0 from "./search-empty.vue?vue&type=style&index=0&id=bbfeb604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfeb604",
  null
  
)

export default component.exports